import React, { useEffect, useState } from "react";
import Select from "react-select";
import apiClient from "../api/apiClient";

const RuteoCamiones = () => {
  // Filtros
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState(null);
  const [entDate, setEntDate] = useState("");
  const [rutaIni, setRutaIni] = useState("");

  // Ruteo pendiente (grupos por institución)
  const [groups, setGroups] = useState([]); // [{ key, code, items:[{DocEntry,DocNum,U_Serv}], order }]
  const [loadingRuteo, setLoadingRuteo] = useState(false);
  const [savingRuteo, setSavingRuteo] = useState(false);

  // Camiones/Choferes y entregas
  const [choferes, setChoferes] = useState([]);
  const [camiones, setCamiones] = useState([]);
  const [chofer, setChofer] = useState(null);
  const [camion, setCamion] = useState(null);
  const [deliveries, setDeliveries] = useState([]);
  const [loadingDeliv, setLoadingDeliv] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const sapUser = JSON.parse(localStorage.getItem("sapUser"));
  const Company = sapUser?.CompanyDB || "";

  // Cargar catálogos (proyectos, choferes, camiones)
  useEffect(() => {
    const loadAll = async () => {
      try {
        const [proRes, chRes, caRes] = await Promise.all([
          apiClient.get("/sales-orders/projects"),
          apiClient.get("/logistica/choferes", { params: { company: Company } }),
          apiClient.get("/logistica/camiones", { params: { company: Company } }),
        ]);
        setProjects((proRes.data || []).map(p => ({ value: p.PrjCode, label: p.PrjName })));
        setChoferes((chRes.data || []).map(p => ({ value: p.Code, label: p.U_NOMBRE })));
        setCamiones((caRes.data || []).map(p => ({ value: p.Code, label: `${p.U_CHAPA} - ${p.U_MODELO}` })));
      } catch (e) {
        console.error(e);
        setError("Error al cargar datos iniciales.");
      }
    };
    loadAll();
  }, [Company]);

  // Construir grupos de ruteo a partir del arreglo de entregas (una sola fuente de datos)
  const buildGroupsFromDeliveries = (arr) => {
    const map = new Map();
    arr.forEach((row) => {
      const key = row.Institucion || row.Name || row.CntctCode || row.CntctCode_ || "Sin Institucion";
      const code = row.CntctCode || row.CntctCode_ || null;
      const serv = row.U_Serv || row.U_Serv_ || "";
      if (!map.has(key)) map.set(key, { key, code, items: [] });
      map.get(key).items.push({ DocEntry: row.DocEntry, DocNum: row.DocNum, U_Serv: serv });
    });
    setGroups(Array.from(map.values()).map((g, i) => ({ ...g, order: i + 1 })));
  };

  const moveUp = (i) => {
    if (i <= 0) return; const a = [...groups]; [a[i-1], a[i]] = [a[i], a[i-1]]; setGroups(a.map((g, idx) => ({ ...g, order: idx + 1 })));
  };
  const moveDown = (i) => {
    if (i >= groups.length - 1) return; const a = [...groups]; [a[i+1], a[i]] = [a[i], a[i+1]]; setGroups(a.map((g, idx) => ({ ...g, order: idx + 1 })));
  };

  const generarRuteo = async () => {
    setSavingRuteo(true); setError("");
    try {
      const details = [];
      groups.forEach(g => g.items.forEach(it => details.push({ U_DocEntry: it.DocEntry, U_Orden: g.order, U_Estado: "PE" })));
      const payload = {
        U_Project: project?.value ?? "",
        U_FechaEnt: entDate,
        U_RutaIni: rutaIni,
        RUTEO_DETCollection: details,
      };
      const res = await apiClient.post("/ruteo-pendiente", payload);
      if (res && (res.status === 200 || res.status === 201)) {
        setMessage("Ruteo generado correctamente.");
      } else {
        setError("Respuesta inesperada al generar ruteo.");
      }
    } catch (e) {
      console.error(e);
      setError("Error al generar ruteo.");
    } finally {
      setSavingRuteo(false);
    }
  };

  // Obtener ruteo y entregas en un solo paso
  const obtenerRuteoYEntregas = async () => {
    // Usamos una única fuente: las entregas también construyen los grupos de ruteo
    await fetchDeliveries();
  };

  // Acción combinada: Actualizar entregas y luego generar ruteo (con el orden actual)
  const actualizarYGenerar = async () => {
    if (!chofer?.value || !camion?.value) { alert("Selecciona chofer y camión."); return; }
    if (!groups.length) { alert("Primero obtené y ordená el ruteo (Obtener Ruteo)." ); return; }
    if (!deliveries.length) { alert("Cargá las entregas de la ruta antes de continuar."); return; }
    try {
      setSubmitting(true); setSavingRuteo(true); setError(""); setMessage("");
      // 1) Actualizar entregas con chofer/camión
      const updates = deliveries.map(row => ({
        DocEntry: row.DocEntry,
        U_CHOFERES: chofer.value,
        U_VEHICULO: camion.value,
        U_Enviar: "SI",
        U_dKmR: 10,
        U_iMotEmiNR: 8,
      }));
      const respUpd = await apiClient.patch("/inventario/entregas", { orders: updates });
      const resUpd = respUpd?.data || [];
      const okUpd = resUpd.filter(r => r.status === "success").length;
      const badUpd = resUpd.filter(r => r.status === "error").length;

      // 2) Generar ruteo con el orden actual
      const details = [];
      groups.forEach(g => g.items.forEach(it => details.push({ U_DocEntry: it.DocEntry, U_Orden: g.order, U_Estado: "PE" })));
      const payload = { U_Project: project?.value ?? "", U_FechaEnt: entDate, U_RutaIni: rutaIni, RUTEO_DETCollection: details };
      const respRut = await apiClient.post("/ruteo-pendiente", payload);
      const rutOk = respRut && (respRut.status === 200 || respRut.status === 201);

      alert(`${okUpd} entregas actualizadas${badUpd ? `, ${badUpd} con error` : ""}.\n${rutOk ? "Ruteo generado correctamente." : "No se pudo confirmar la generación del ruteo."}`);
      await fetchDeliveries();
    } catch (e) {
      console.error(e);
      alert("Fallo la acción combinada: actualizar y generar ruteo.");
    } finally {
      setSubmitting(false); setSavingRuteo(false);
    }
  };

  // Entregas para asignar chofer/camión: usamos todas las entregas cargadas

  const fetchDeliveries = async () => {
    setLoadingDeliv(true); setLoadingRuteo(true); setError("");
    try {
      const resp = await apiClient.get("/logistica/remisiones", {
        params: {
          project: project?.value ?? "",
          start_route: rutaIni,
          end_route: rutaIni,
          entDate,
          company: Company,
        }
      });
      const arr = Array.isArray(resp.data) ? resp.data : [];
      const mapped = arr.map(any => ({
        DocEntry: any.DocEntry,
        DocNum: any.DocNum,
        Project: any.Project,
        Gobernacion: any.CardName,
        Institucion: any.Name || any.Institucion,
        CntctCode: any.CntctCode,
        U_Serv: any.U_Serv,
        FechaEntrega: any.DocDueDate || entDate || "",
      }));
      setDeliveries(mapped);
      // Construimos grupos de ruteo desde las mismas entregas
      buildGroupsFromDeliveries(arr);
    } catch (e) {
      console.error(e);
      setError("Error al obtener entregas.");
    } finally {
      setLoadingDeliv(false); setLoadingRuteo(false);
    }
  };

  const actualizarEntregas = async () => {
    if (!deliveries.length) { alert("No hay entregas para actualizar."); return; }
    if (!chofer?.value || !camion?.value) { alert("Selecciona chofer y camión."); return; }
    try {
      setSubmitting(true);
      const updates = deliveries.map(row => ({
        DocEntry: row.DocEntry,
        U_CHOFERES: chofer.value,
        U_VEHICULO: camion.value,
        U_Enviar: "SI",
        U_dKmR: 10,
        U_iMotEmiNR: 8,
      }));
      const resp = await apiClient.patch("/inventario/entregas", { orders: updates });
      const results = resp?.data || [];
      const ok = results.filter(r => r.status === "success").length;
      const bad = results.filter(r => r.status === "error").length;
      alert(`${ok} entregas actualizadas.${bad ? ` ${bad} con error.` : ""}`);
      await fetchDeliveries();
    } catch (e) {
      console.error(e);
      alert("Error al actualizar entregas");
    } finally {
      setSubmitting(false);
    }
  };
  // Sin columnas: removimos la tabla inferior

  return (
    <div className="container mt-4">
      <h2>Asignación de Camiones y Ruteo</h2>
      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}

      {/* Fila 1: filtros principales */}
      <div className="row g-3 align-items-end">
        <div className="col-lg-3 col-md-4">
          <label className="form-label">Proyecto</label>
          <Select options={projects} value={project} onChange={setProject} placeholder="Seleccione un proyecto..." isSearchable />
        </div>
        <div className="col-lg-2 col-md-3">
          <label className="form-label">Fecha Entrega</label>
          <input type="date" className="form-control" value={entDate} onChange={(e) => setEntDate(e.target.value)} />
        </div>
        <div className="col-lg-2 col-md-3">
          <label className="form-label">Ruta</label>
          <input type="number" className="form-control" value={rutaIni} onChange={(e) => setRutaIni(e.target.value)} />
        </div>
      </div>

      {/* Fila 2: chofer y camión */}
      <div className="row g-3 align-items-end mt-1">
        <div className="col-lg-3 col-md-4">
          <label className="form-label">Chofer</label>
          <Select options={choferes} value={chofer} onChange={setChofer} placeholder="Seleccione un chofer..." isSearchable />
        </div>
        <div className="col-lg-3 col-md-4">
          <label className="form-label">Camión</label>
          <Select options={camiones} value={camion} onChange={setCamion} placeholder="Seleccione un camión..." isSearchable />
        </div>
      </div>

      {/* Ruteo Pendiente */}
      <div className="mt-3">
        <div className="d-flex gap-2 flex-wrap">
          <button className="btn btn-success" onClick={obtenerRuteoYEntregas} disabled={loadingRuteo || loadingDeliv}>
            {loadingRuteo || loadingDeliv ? "Cargando..." : "Obtener Ruteo y Entregas"}
          </button>
          {/* <button className="btn btn-primary" onClick={generarRuteo} disabled={!groups.length || savingRuteo}>{savingRuteo ? "Generando..." : "Generar Ruteo"}</button> */}
          {/* <button className="btn btn-outline-success" onClick={actualizarEntregas} disabled={!deliveries.length || !chofer || !camion || submitting}>{submitting ? "Actualizando..." : "Aplicar a Entregas"}</button> */}
          <button className="btn btn-dark" onClick={actualizarYGenerar} disabled={!groups.length || !deliveries.length || !chofer || !camion || submitting || savingRuteo}>
            {submitting || savingRuteo ? "Procesando..." : "Actualizar Registros"}
          </button>
        </div>
        <div className="mt-2">
          <p>Instituciones: {groups.length}</p>
          {groups.map((g, idx) => (
            <div key={g.key + idx} className="p-2 mb-2 border rounded">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <strong>{g.order}.</strong> <strong>{g.key}</strong>
                  {g.code ? <small className="text-muted ms-2">({g.code})</small> : null}
                </div>
                <div className="btn-group btn-group-sm">
                  <button className="btn btn-outline-secondary" onClick={() => moveUp(idx)} disabled={idx === 0}>↑</button>
                  <button className="btn btn-outline-secondary" onClick={() => moveDown(idx)} disabled={idx === groups.length - 1}>↓</button>
                </div>
              </div>
              <div className="mt-2 ps-2">
                {g.items.map((it) => (
                  <div key={it.DocEntry} className="d-flex gap-3 border-bottom py-1 small">
                    <div>ID: {it.DocEntry}</div>
                    <div>Doc: {it.DocNum}</div>
                    <div>Serv: {it.U_Serv}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Se elimina la tabla inferior y la sección duplicada; la asignación se realiza con los controles superiores */}
    </div>
  );
};

export default RuteoCamiones;
